import type { ComponentSize } from '../../utility';

export const INPUT_SIZE_CLASSES: Record<ComponentSize, string> = {
  32: 'tw-input-32',
  36: 'tw-input-36',
  44: 'tw-input-44',
};

export const INPUT_SIZE_DEFAULT = 36;
